import { render, staticRenderFns } from "./AdvertisingModuleV1Dashboard.vue?vue&type=template&id=1f6b6675&scoped=true"
import script from "./AdvertisingModuleV1Dashboard.vue?vue&type=script&lang=js"
export * from "./AdvertisingModuleV1Dashboard.vue?vue&type=script&lang=js"
import style0 from "./AdvertisingModuleV1Dashboard.vue?vue&type=style&index=0&id=1f6b6675&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6b6675",
  null
  
)

export default component.exports